import { Box, Hint, tokens } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

export const ScheduleMyProjectsHint = () => {
  const [scheduleMyProjectsHintIsHidden, setScheduleMyProjectsHintIsHidden] =
    useLocalStorage<boolean>(LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideScheduleMyProjectsHint)

  useEffect(() => {
    track(trackingEvents.projectManagement.hints.viewScheduleMyProjectsHint)
  }, [])

  const handleHintClose = () => {
    track(trackingEvents.projectManagement.hints.closeScheduleMyProjectsHint)
    setScheduleMyProjectsHintIsHidden(true)
  }

  return (
    <Hint.Popover.Provider
      steps={1}
      isHidden={scheduleMyProjectsHintIsHidden}
      onClose={handleHintClose}
      onFinish={handleHintClose}
    >
      <Box position="absolute" style={{ top: '-5%', left: '8%', zIndex: tokens.zIndex.popovers }}>
        <Hint.Popover
          step={1}
          title={i18n.t('project_management.hints.schedule_my_projects.title')}
          description={i18n.t('project_management.hints.schedule_my_projects.description')}
        />
      </Box>
    </Hint.Popover.Provider>
  )
}
